import React,{Component} from 'react'
import { connect } from 'react-redux'
import {Translate} from '../../../utils/lang/translate'
import {UnderDevPage} from '../_Common/UnderDevPage'
class SubscriptionPage extends Component{
    render(){
        return(
            <div className="ClSidTh StBrdTb FlWd StBgbrds RlPs lytWdp stbd2 StDrc">
                <div className="stbd2">
                    <h3 className="DlMg">{Translate('settings','premium')}</h3>
                </div>
                <UnderDevPage/>
            </div>
        )
    }
    
}
function mapState(state) {
     return {}
}

const actionCreators = {
    
};

const connectedSubscriptionPage = connect(mapState, actionCreators)(SubscriptionPage);
export { connectedSubscriptionPage as SubscriptionPage };